class SmartField extends HTMLElement {
  constructor() {
    super();
    
    // Inject HTML
    this.render();

    // Set up refs
    this.input = this.querySelector('input');

    // Set up event listeners
    this.listen();
  }
  
  render() {
    this.innerHTML = `
      <input 
        type="${ this.getAttribute('type' ) }"
        name="${ this.getAttribute('name' ) }"
        id="${ this.getAttribute('id' ) }"
        placeholder="${ this.getAttribute('aria-label' ) }"
        ${ this.getAttribute('autocomplete') ? 
          `autocomplete="${ this.getAttribute('autocomplete') }"`
        : '' }
        ${ (this.getAttribute('required') !== null) ? 
          `required="${ this.getAttribute('required') }"`
        : '' }
        ${ this.getAttribute('value') ? 
          `value="${ this.getAttribute('value') }"` 
        : '' }
      >
      <label for="${ this.getAttribute('id') }">${ this.getAttribute('aria-label') }</label>
    `;
  }
  
  listen() {
    this.input.addEventListener('blur', e => {
      this.classList.add('_input_completed');
    });
    
    this.input.addEventListener('change', e => {
      this.classList.remove('_input_completed');
    });
  }
}

// Define the custom element
customElements.define('smart-field', SmartField);